/**
 * @desc 分页
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.ResponseDto<
  defs.rms.IPage<defs.rms.ExpenseReimbursementDetailResponseDto>
>;
export function request(
  params: API.rms.expenseReimbursementDetail.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/expenseReimbursementDetail/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
